// import { 
//   Box, 
//   Container, 
//   Typography, 
//   Grid, 
//   Card,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Stack,
//   Button,
//   Paper,
//   Chip,
//   Accordion,
//   AccordionSummary,
//   AccordionDetails
// } from '@mui/material';
// import {
//   Widgets as WidgetIcon,
//   DragIndicator as DragIcon,
//   ViewQuilt as GridIcon,
//   Visibility as PreviewIcon,
//   Dashboard as DashboardIcon,
//   CheckCircle as CheckIcon,
//   ExpandMore as ExpandIcon,
//   ViewCarousel as SliderIcon,
//   ViewList as ListIcon,
//   Category as CategoryIcon,
//   Person as PersonIcon,
//   AttachMoney as MoneyIcon,
//   WbSunny as WeatherIcon,
//   Sports as SportsIcon,
//   Stars as HoroscopeIcon,
//   Article as ArticleIcon,
//   ViewAgenda
// } from '@mui/icons-material';
// import { useState } from 'react';

// const PageDesignPage = () => {
//   const [hoveredCard, setHoveredCard] = useState(null);
//   const [expanded, setExpanded] = useState('panel1');

//   const handleAccordionChange = (panel) => (event, isExpanded) => {
//     setExpanded(isExpanded ? panel : false);
//   };

//   // Sayfa Tasarımcısı Özellikleri
//   const designerFeatures = [
//     {
//       icon: <DragIcon sx={{ fontSize: 50 }} />,
//       title: "Sürükle-Bırak Arayüz",
//       description: "Widget'ları kolayca sürükleyip bırakarak sayfanızı tasarlayın",
//       color: "#1e40af",
//       gradient: "linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)"
//     },
//     {
//       icon: <GridIcon sx={{ fontSize: 50 }} />,
//       title: "12 Kolon Grid Sistemi",
//       description: "Responsive ve esnek grid yapısı ile mükemmel düzen",
//       color: "#dc2626",
//       gradient: "linear-gradient(135deg, #dc2626 0%, #ef4444 100%)"
//     },
//     {
//       icon: <WidgetIcon sx={{ fontSize: 50 }} />,
//       title: "70+ Widget Kütüphanesi",
//       description: "Hazır widget'larla zengin içerik tasarımları",
//       color: "#059669",
//       gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)"
//     },
//     {
//       icon: <PreviewIcon sx={{ fontSize: 50 }} />,
//       title: "Canlı Önizleme",
//       description: "Değişiklikleri anında görün ve test edin",
//       color: "#7c3aed",
//       gradient: "linear-gradient(135deg, #7c3aed 0%, #8b5cf6 100%)"
//     },
//     {
//       icon: <DashboardIcon sx={{ fontSize: 50 }} />,
//       title: "Sayfa Şablonları",
//       description: "Hazır şablonlarla hızlı başlangıç yapın",
//       color: "#ea580c",
//       gradient: "linear-gradient(135deg, #ea580c 0%, #f97316 100%)"
//     },
//     {
//       icon: <ViewAgenda sx={{ fontSize: 50 }} />,
//       title: "Özelleştirilebilir Boyut",
//       description: "Her widget için tam boyut kontrolü",
//       color: "#0891b2",
//       gradient: "linear-gradient(135deg, #0891b2 0%, #06b6d4 100%)"
//     }
//   ];

//   // Widget Kategorileri
//   const widgetCategories = [
//     {
//       id: 'panel1',
//       icon: <SliderIcon />,
//       title: "Ana Manşet Widget'ları",
//       count: "10+",
//       color: "#1e40af",
//       items: [
//         "Slider manşet widget'ları (6 farklı stil)",
//         "Video manşet widget'ları",
//         "Tam ekran hero widget'lar",
//         "Otomatik geçiş ve manuel kontrol"
//       ]
//     },
//     {
//       id: 'panel2',
//       icon: <ListIcon />,
//       title: "Haber Listeleme Widget'ları",
//       count: "30+",
//       color: "#dc2626",
//       items: [
//         "Grid layout'lar (2x1, 3x1, 3x2, 3x4, 4x4)",
//         "Liste görünümleri (dikey, yatay, kompakt)",
//         "Kart tasarımları (modern, klasik, magazin)",
//         "Timeline ve kronolojik görünümler",
//         "Masonry (Pinterest tarzı) layout",
//         "Ticker ve kayan haber bantları",
//         "Numaralı haber slider'ı"
//       ]
//     },
//     {
//       id: 'panel3',
//       icon: <CategoryIcon />,
//       title: "Kategori Widget'ları",
//       count: "6+",
//       color: "#059669",
//       items: [
//         "Tab'lı kategori widget'ları (3 varyasyon)",
//         "Kategori grid'leri",
//         "Dropdown kategori menüleri",
//         "Desktop kategori navigasyonu"
//       ]
//     },
//     {
//       id: 'panel4',
//       icon: <PersonIcon />,
//       title: "Yazar/Köşe Yazarı Widget'ları",
//       count: "5+",
//       color: "#7c3aed",
//       items: [
//         "Yazar profil kartları",
//         "Köşe yazarı slider'ları (2 varyasyon)",
//         "Yazar listesi widget'ları",
//         "Yazar detay widget'ları"
//       ]
//     },
//     {
//       id: 'panel5',
//       icon: <MoneyIcon />,
//       title: "Finans Widget'ları",
//       count: "8+",
//       color: "#ea580c",
//       items: [
//         "Döviz kurları (3 varyasyon)",
//         "Altın fiyatları",
//         "Kripto para (2 varyasyon)",
//         "Borsa widget'ları",
//         "Kayan finans ticker",
//         "Yatay finans widget"
//       ]
//     },
//     {
//       id: 'panel6',
//       icon: <WeatherIcon />,
//       title: "Hava Durumu Widget'ları",
//       count: "4+",
//       color: "#0891b2",
//       items: [
//         "4 farklı tasarım seçeneği",
//         "Şehir bazlı hava durumu",
//         "5 günlük tahmin",
//         "Detaylı meteoroloji bilgisi"
//       ]
//     },
//     {
//       id: 'panel7',
//       icon: <SportsIcon />,
//       title: "Spor Widget'ları",
//       count: "4+",
//       color: "#db2777",
//       items: [
//         "Lig tablosu widget",
//         "Maç sonuçları widget",
//         "Spor ticker widget",
//         "Canlı skor desteği"
//       ]
//     },
//     {
//       id: 'panel8',
//       icon: <ArticleIcon />,
//       title: "Genel & Özel Widget'lar",
//       count: "20+",
//       color: "#16a34a",
//       items: [
//         "Newsletter/Bülten widget",
//         "Trend haberler",
//         "Popüler haberler",
//         "Video widget",
//         "Görsel widget",
//         "Sosyal medya feed",
//         "Arama widget",
//         "Etiket bulutu",
//         "Reklam yönetimi"
//       ]
//     }
//   ];

//   return (
//     <Box>
//       {/* Hero Section */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: `
//             linear-gradient(
//               135deg,
//               #1e40af 0%,
//               #3b82f6 50%,
//               #8b5cf6 100%
//             )
//           `,
//           position: 'relative',
//           overflow: 'hidden',
//           color: 'white',
//           '&::before': {
//             content: '""',
//             position: 'absolute',
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             background: `
//               radial-gradient(circle at 30% 20%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
//               radial-gradient(circle at 70% 80%, rgba(255, 255, 255, 0.1) 0%, transparent 50%)
//             `,
//             pointerEvents: 'none'
//           }
//         }}
//       >
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', position: 'relative', zIndex: 1 }}>
//             <Box
//               sx={{
//                 display: 'inline-flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 width: 100,
//                 height: 100,
//                 borderRadius: '50%',
//                 background: 'rgba(255, 255, 255, 0.2)',
//                 backdropFilter: 'blur(10px)',
//                 mb: 4,
//                 mx: 'auto'
//               }}
//             >
//               <WidgetIcon sx={{ fontSize: 60, color: 'white' }} />
//             </Box>

//             <Typography
//               variant="overline"
//               sx={{
//                 fontSize: '0.9rem',
//                 fontWeight: 900,
//                 letterSpacing: '0.15em',
//                 color: 'rgba(255,255,255,0.9)',
//                 mb: 2,
//                 display: 'block',
//                 textTransform: 'uppercase'
//               }}
//             >
//               SAYFA TASARIM SİSTEMİ
//             </Typography>

//             <Typography
//               variant="h1"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '4.5rem' },
//                 fontWeight: 800,
//                 mb: 4,
//                 color: 'white',
//                 fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
//                 lineHeight: 1.1
//               }}
//             >
//               70+ Widget ile Sınırsız Tasarım
//             </Typography>

//             <Typography
//               variant="h5"
//               sx={{
//                 fontSize: { xs: '1.2rem', md: '1.5rem' },
//                 color: 'rgba(255,255,255,0.9)',
//                 maxWidth: 800,
//                 mx: 'auto',
//                 lineHeight: 1.6,
//                 fontWeight: 400,
//                 mb: 6
//               }}
//             >
//               Sürükle-bırak arayüzü ile kod yazmadan profesyonel sayfalar tasarlayın. 
//               70+ hazır widget ile sınırsız kombinasyon imkanı
//             </Typography>

//             <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
//               <Button
//                 variant="contained"
//                 size="large"
//                 sx={{
//                   background: 'white',
//                   color: '#1e40af',
//                   px: 5,
//                   py: 2,
//                   fontSize: '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   textTransform: 'none',
//                   '&:hover': {
//                     background: '#f8fafc',
//                     transform: 'translateY(-2px)',
//                     boxShadow: '0 10px 30px rgba(0, 0, 0, 0.2)'
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 Widget Galerisini İncele
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="large"
//                 sx={{
//                   borderColor: 'white',
//                   color: 'white',
//                   px: 5,
//                   py: 2,
//                   fontSize: '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   borderWidth: 2,
//                   textTransform: 'none',
//                   '&:hover': {
//                     borderWidth: 2,
//                     background: 'rgba(255, 255, 255, 0.1)',
//                     transform: 'translateY(-2px)'
//                   },
//                   transition: 'all 0.3s ease'
//                 }}
//               >
//                 Canlı Demo
//               </Button>
//             </Stack>
//           </Box>
//         </Container>
//       </Box>

//       {/* Tasarımcı Özellikleri */}
//       <Box sx={{ py: { xs: 10, md: 16 }, background: '#f8fafc' }}>
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', mb: 10 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 fontWeight: 800,
//                 mb: 3,
//                 background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent'
//               }}
//             >
//               Görsel Sayfa Tasarımcısı
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#64748b',
//                 maxWidth: 700,
//                 mx: 'auto',
//                 lineHeight: 1.6
//               }}
//             >
//               Kod bilgisi gerektirmeyen, kullanıcı dostu tasarım araçları
//             </Typography>
//           </Box>

//           <Grid container spacing={4}>
//             {designerFeatures.map((feature, index) => (
//               <Grid item xs={12} sm={6} md={4} key={index}>
//                 <Paper
//                   elevation={0}
//                   onMouseEnter={() => setHoveredCard(index)}
//                   onMouseLeave={() => setHoveredCard(null)}
//                   sx={{
//                     p: 4,
//                     height: '100%',
//                     background: 'white',
//                     border: '1px solid #e2e8f0',
//                     borderRadius: 4,
//                     textAlign: 'center',
//                     cursor: 'pointer',
//                     transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
//                     position: 'relative',
//                     overflow: 'hidden',
//                     '&::before': {
//                       content: '""',
//                       position: 'absolute',
//                       top: 0,
//                       left: 0,
//                       right: 0,
//                       height: 4,
//                       background: feature.gradient,
//                       transform: hoveredCard === index ? 'scaleX(1)' : 'scaleX(0)',
//                       transformOrigin: 'left',
//                       transition: 'transform 0.3s ease'
//                     },
//                     '&:hover': {
//                       transform: 'translateY(-8px)',
//                       boxShadow: `0 20px 40px ${feature.color}20`,
//                       borderColor: feature.color
//                     }
//                   }}
//                 >
//                   <Box
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       justifyContent: 'center',
//                       width: 80,
//                       height: 80,
//                       borderRadius: 3,
//                       background: `${feature.color}15`,
//                       color: feature.color,
//                       mb: 3,
//                       transition: 'all 0.4s ease',
//                       transform: hoveredCard === index ? 'scale(1.1) rotate(5deg)' : 'scale(1)'
//                     }}
//                   >
//                     {feature.icon}
//                   </Box>

//                   <Typography
//                     variant="h6"
//                     sx={{
//                       fontWeight: 700,
//                       mb: 2,
//                       color: '#1e293b',
//                       fontSize: '1.1rem'
//                     }}
//                   >
//                     {feature.title}
//                   </Typography>

//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: '#64748b',
//                       lineHeight: 1.6
//                     }}
//                   >
//                     {feature.description}
//                   </Typography>
//                 </Paper>
//               </Grid>
//             ))}
//           </Grid>
//         </Container>
//       </Box>

//       {/* Widget Kütüphanesi */}
//       <Box sx={{ py: { xs: 10, md: 16 }, background: 'white' }}>
//         <Container maxWidth="xl">
//           <Box sx={{ textAlign: 'center', mb: 10 }}>
//             <Typography
//               variant="h2"
//               sx={{
//                 fontSize: { xs: '2.5rem', md: '3.5rem' },
//                 fontWeight: 800,
//                 mb: 3,
//                 background: 'linear-gradient(135deg, #dc2626 0%, #7c3aed 100%)',
//                 backgroundClip: 'text',
//                 WebkitBackgroundClip: 'text',
//                 WebkitTextFillColor: 'transparent'
//               }}
//             >
//               70+ Hazır Widget Kütüphanesi
//             </Typography>
//             <Typography
//               variant="h6"
//               sx={{
//                 color: '#64748b',
//                 maxWidth: 700,
//                 mx: 'auto'
//               }}
//             >
//               Her ihtiyacınız için özel tasarlanmış widget'lar
//             </Typography>
//           </Box>

//           <Box sx={{ maxWidth: 1000, mx: 'auto' }}>
//             {widgetCategories.map((category, index) => (
//               <Accordion
//                 key={category.id}
//                 expanded={expanded === category.id}
//                 onChange={handleAccordionChange(category.id)}
//                 sx={{
//                   mb: 2,
//                   borderRadius: 3,
//                   border: '1px solid #e2e8f0',
//                   '&:before': { display: 'none' },
//                   '&.Mui-expanded': {
//                     boxShadow: `0 10px 30px ${category.color}20`
//                   }
//                 }}
//               >
//                 <AccordionSummary
//                   expandIcon={<ExpandIcon />}
//                   sx={{
//                     '&.Mui-expanded': {
//                       background: `${category.color}05`
//                     }
//                   }}
//                 >
//                   <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', gap: 2 }}>
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         width: 50,
//                         height: 50,
//                         borderRadius: 2,
//                         background: `${category.color}15`,
//                         color: category.color
//                       }}
//                     >
//                       {category.icon}
//                     </Box>
//                     <Typography variant="h6" sx={{ fontWeight: 700, flex: 1 }}>
//                       {category.title}
//                     </Typography>
//                     <Chip
//                       label={category.count}
//                       size="small"
//                       sx={{
//                         background: category.color,
//                         color: 'white',
//                         fontWeight: 600
//                       }}
//                     />
//                   </Box>
//                 </AccordionSummary>
//                 <AccordionDetails>
//                   <List dense>
//                     {category.items.map((item, idx) => (
//                       <ListItem key={idx} sx={{ py: 1 }}>
//                         <ListItemIcon sx={{ minWidth: 32 }}>
//                           <CheckIcon sx={{ color: category.color, fontSize: 20 }} />
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={item}
//                           primaryTypographyProps={{
//                             fontSize: '1rem',
//                             color: '#475569'
//                           }}
//                         />
//                       </ListItem>
//                     ))}
//                   </List>
//                 </AccordionDetails>
//               </Accordion>
//             ))}
//           </Box>
//         </Container>
//       </Box>

//       {/* CTA Section */}
//       <Box
//         sx={{
//           py: { xs: 10, md: 16 },
//           background: 'linear-gradient(135deg, #0f172a 0%, #1e40af 100%)',
//           color: 'white',
//           textAlign: 'center'
//         }}
//       >
//         <Container maxWidth="md">
//           <Typography
//             variant="h2"
//             sx={{
//               fontSize: { xs: '2.5rem', md: '3.5rem' },
//               fontWeight: 800,
//               mb: 3
//             }}
//           >
//             Hayalinizdeki Tasarımı Oluşturun
//           </Typography>
//           <Typography
//             variant="h6"
//             sx={{
//               mb: 6,
//               opacity: 0.9,
//               lineHeight: 1.6
//             }}
//           >
//             70+ widget ile sınırsız kombinasyon imkanı. Kod bilgisi gerektirmez!
//           </Typography>
//           <Button
//             variant="contained"
//             size="large"
//             sx={{
//               background: 'white',
//               color: '#1e40af',
//               px: 6,
//               py: 2.5,
//               fontSize: '1.2rem',
//               fontWeight: 700,
//               borderRadius: 2,
//               textTransform: 'none',
//               '&:hover': {
//                 background: '#f8fafc',
//                 transform: 'translateY(-2px)',
//                 boxShadow: '0 10px 30px rgba(255, 255, 255, 0.3)'
//               },
//               transition: 'all 0.3s ease'
//             }}
//           >
//             Hemen Başlayın
//           </Button>
//         </Container>
//       </Box>
//     </Box>
//   );
// };

// export default PageDesignPage;



import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  Paper,
  IconButton,
  Avatar,
  Divider
} from '@mui/material';
import {
  Widgets as WidgetIcon,
  DragIndicator as DragIcon,
  ViewModule as GridIcon,
  Palette as PaletteIcon,
  Devices as DevicesIcon,
  Visibility as PreviewIcon,
  Save as SaveIcon,
  ContentCopy as CopyIcon,
  ArrowForward as ArrowIcon,
  PlayCircle as PlayIcon,
  CheckCircle as CheckIcon,
  AutoAwesome as MagicIcon,
  Speed as SpeedIcon,
  TouchApp as TouchIcon,
  Code as CodeIcon,
  DesignServices as DesignIcon
} from '@mui/icons-material';

const PageDesignerPage = () => {
  const [hoveredWidget, setHoveredWidget] = useState(null);
  const [activeDemo, setActiveDemo] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  // Widget Kategorileri
  const widgetCategories = [
    {
      id: 'manset',
      name: 'Ana Manşet',
      count: '10+',
      icon: '📰',
      color: '#3b82f6',
      description: 'Slider ve hero widget\'ları'
    },
    {
      id: 'liste',
      name: 'Haber Listeleri',
      count: '30+',
      icon: '📋',
      color: '#10b981',
      description: 'Grid ve liste düzenleri'
    },
    {
      id: 'kategori',
      name: 'Kategori',
      count: '5+',
      icon: '📂',
      color: '#f59e0b',
      description: 'Tab ve navigasyon'
    },
    {
      id: 'yazar',
      name: 'Yazar',
      count: '3+',
      icon: '✍️',
      color: '#8b5cf6',
      description: 'Köşe yazarı widget\'ları'
    },
    {
      id: 'finans',
      name: 'Finans',
      count: '8+',
      icon: '💱',
      color: '#ec4899',
      description: 'Döviz, altın, kripto'
    },
    {
      id: 'hava',
      name: 'Hava Durumu',
      count: '4+',
      icon: '☀️',
      color: '#06b6d4',
      description: 'Hava durumu widget\'ları'
    },
    {
      id: 'spor',
      name: 'Spor',
      count: '3+',
      icon: '⚽',
      color: '#ef4444',
      description: 'Lig ve maç sonuçları'
    },
    {
      id: 'extra',
      name: 'Ekstra',
      count: '15+',
      icon: '🎯',
      color: '#f97316',
      description: 'Burç, newsletter, sosyal'
    }
  ];

  // Tasarımcı Özellikleri
  const designerFeatures = [
    {
      icon: <DragIcon />,
      title: 'Görerek Tasarla',
      description: 'Widget\'ları görerek istediğiniz yere bırakın',
      color: '#3b82f6',
      stat: '70+ Widget'
    },
    {
      icon: <GridIcon />,
      title: '12 Kolon Grid',
      description: 'Esnek grid sistemi ile responsive tasarım',
      color: '#10b981',
      stat: 'Responsive'
    },
    {
      icon: <PreviewIcon />,
      title: 'Canlı Önizleme',
      description: 'Değişiklikleri anında görün',
      color: '#f59e0b',
      stat: 'Real-time'
    },
    {
      icon: <SaveIcon />,
      title: 'Şablon Kaydet',
      description: 'Tasarımlarınızı şablon olarak saklayın',
      color: '#8b5cf6',
      stat: 'Sınırsız'
    },
    {
      icon: <DevicesIcon />,
      title: 'Çoklu Cihaz',
      description: 'Mobil, tablet ve desktop görünümleri',
      color: '#ec4899',
      stat: '3 Cihaz'
    },
    {
      icon: <CodeIcon />,
      title: 'Kod Gerektirmez',
      description: 'Tamamen görsel arayüz ile çalışın',
      color: '#06b6d4',
      stat: 'No-Code'
    }
  ];

  // Süreç Adımları
  const steps = [
    {
      number: '01',
      title: 'Widget Seç',
      description: '70+ widget arasından seçim yapın',
      icon: <WidgetIcon />,
      color: '#3b82f6'
    },
    {
      number: '02',
      title: 'Görerek Tasarla',
      description: 'Widget\'ları görerek istediğiniz yere bırakın',
      icon: <DragIcon />,
      color: '#10b981'
    },
    {
      number: '03',
      title: 'Özelleştir',
      description: 'Renk, boyut ve içerik ayarlarını yapın',
      icon: <PaletteIcon />,
      color: '#f59e0b'
    },
    {
      number: '04',
      title: 'Yayınla',
      description: 'Tasarımınızı kaydedin ve yayınlayın',
      icon: <CheckIcon />,
      color: '#8b5cf6'
    }
  ];

  // Demo Animasyonu
  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setActiveDemo((prev) => (prev + 1) % 3);
        setIsAnimating(false);
      }, 500);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
      
      {/* Hero Section */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          pt: { xs: 12, md: 16 },
          pb: { xs: 10, md: 15 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Animated Blobs */}
        <Box
          sx={{
            position: 'absolute',
            top: -150,
            right: -150,
            width: 500,
            height: 500,
            background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
            borderRadius: '40% 60% 70% 30% / 40% 50% 60% 50%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 10s ease-in-out infinite'
          }}
        />

        <Box
          sx={{
            position: 'absolute',
            bottom: -100,
            left: -100,
            width: 400,
            height: 400,
            background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
            borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
            opacity: 0.1,
            filter: 'blur(80px)',
            animation: 'morph 12s ease-in-out infinite reverse'
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Chip
                label="SAYFA TASARIMCISI"
                icon={<MagicIcon sx={{ fontSize: '1rem' }} />}
                sx={{
                  background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.2), rgba(247, 147, 30, 0.2))',
                  color: '#ff6b35',
                  border: '1px solid rgba(255, 107, 53, 0.3)',
                  backdropFilter: 'blur(10px)',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  mb: 3,
                  px: 2,
                  py: 2.5
                }}
              />
              
              <Typography
                variant="h1"
                sx={{
                  fontSize: { xs: '2.5rem', md: '4.5rem' },
                  fontWeight: 900,
                  color: 'white',
                  mb: 3,
                  lineHeight: 1.1
                }}
              >
                Hayal Ettiğiniz{' '}
                <span style={{ 
                  background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent'
                }}>
                  Tasarımı Oluşturun
                </span>
              </Typography>

              <Typography
                variant="h5"
                sx={{
                  color: 'rgba(255,255,255,0.7)',
                  fontSize: { xs: '1.1rem', md: '1.4rem' },
                  lineHeight: 1.6,
                  mb: 5
                }}
              >
                Kod yazmadan, görerek tasarlayarak profesyonel haber siteleri tasarlayın. 
                70+ widget ile sınırsız tasarım özgürlüğü.
              </Typography>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={3} mb={5}>
                <Button
                  variant="contained"
                  size="large"
                  endIcon={<ArrowIcon />}
                  sx={{
                    background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                    color: 'white',
                    px: 5,
                    py: 2.5,
                    fontSize: '1.1rem',
                    fontWeight: 700,
                    borderRadius: '50px',
                    textTransform: 'none',
                    boxShadow: '0 8px 32px rgba(255, 107, 53, 0.4)',
                    '&:hover': {
                      background: 'linear-gradient(135deg, #f7931e 0%, #ff6b35 100%)',
                      transform: 'translateY(-2px)',
                      boxShadow: '0 12px 40px rgba(255, 107, 53, 0.5)'
                    },
                    transition: 'all 0.3s ease'
                  }}
                >
                  Tasarımcıyı Dene
                </Button>

                <Button
                  variant="outlined"
                  size="large"
                  startIcon={<PlayIcon />}
                  sx={{
                    borderColor: 'rgba(255,255,255,0.3)',
                    color: 'white',
                    px: 5,
                    py: 2.5,
                    fontSize: '1.1rem',
                    fontWeight: 700,
                    borderRadius: '50px',
                    textTransform: 'none',
                    borderWidth: 2,
                    '&:hover': {
                      borderColor: '#ff6b35',
                      color: '#ff6b35',
                      background: 'rgba(255, 107, 53, 0.1)',
                      borderWidth: 2
                    }
                  }}
                >
                  Video İzle
                </Button>
              </Stack>

              {/* Quick Stats */}
              <Grid container spacing={3}>
                {[
                  { icon: <WidgetIcon />, value: '70+', label: 'Widget' },
                  { icon: <TouchIcon />, value: 'Görerek Tasarla', label: 'Kolay Kullanım' },
                  { icon: <SpeedIcon />, value: '30 Dakika', label: 'Hızlı Tasarım' }
                ].map((stat, idx) => (
                  <Grid item xs={4} key={idx}>
                    <Stack direction="row" spacing={1.5} alignItems="center">
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: 2,
                          background: 'rgba(255, 107, 53, 0.2)',
                          color: '#ff6b35',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '1.2rem'
                        }}
                      >
                        {stat.icon}
                      </Box>
                      <Box>
                        <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '0.95rem' }}>
                          {stat.value}
                        </Typography>
                        <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.75rem' }}>
                          {stat.label}
                        </Typography>
                      </Box>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12} md={6}>
              {/* Animasyonlu Tasarımcı Mockup */}
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 30px 80px rgba(0,0,0,0.6)',
                  border: '1px solid rgba(255,255,255,0.1)'
                }}
              >
                {/* Browser Bar */}
                <Box
                  sx={{
                    background: 'rgba(255,255,255,0.95)',
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1
                  }}
                >
                  <Box sx={{ display: 'flex', gap: 0.8 }}>
                    {['#ff5f56', '#ffbd2e', '#27c93f'].map((color, idx) => (
                      <Box
                        key={idx}
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: '50%',
                          background: color
                        }}
                      />
                    ))}
                  </Box>
                  <Box
                    sx={{
                      flex: 1,
                      ml: 2,
                      background: '#f1f3f5',
                      borderRadius: '50px',
                      px: 2,
                      py: 0.5
                    }}
                  >
                    <Typography sx={{ fontSize: '0.8rem', color: '#6c757d' }}>
                      🔒 yoursite.com/page-designer
                    </Typography>
                  </Box>
                </Box>

                {/* Designer Interface */}
                <Box
                  sx={{
                    background: '#f8f9fa',
                    p: 3,
                    minHeight: 450
                  }}
                >
                  {/* Grid Lines */}
                  <Box
                    sx={{
                      position: 'relative',
                      border: '2px dashed #dee2e6',
                      borderRadius: 2,
                      p: 2,
                      minHeight: 400,
                      background: 'white'
                    }}
                  >
                    {/* Simulated Widgets */}
                    <Stack spacing={2}>
                      {/* Widget 1 - Header */}
                      <Box
                        sx={{
                          background: 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)',
                          borderRadius: 2,
                          p: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          opacity: isAnimating ? 0.5 : 1,
                          transform: isAnimating ? 'scale(0.98)' : 'scale(1)',
                          transition: 'all 0.5s ease'
                        }}
                      >
                        <Stack direction="row" spacing={1} alignItems="center">
                          <DragIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
                          <Typography sx={{ color: 'white', fontWeight: 600, fontSize: '0.85rem' }}>
                            Ana Manşet Widget
                          </Typography>
                        </Stack>
                        <Typography sx={{ color: 'white', fontSize: '0.75rem' }}>
                          12 x 6
                        </Typography>
                      </Box>

                      {/* Widget 2 & 3 - Grid */}
                      <Grid container spacing={2}>
                        <Grid item xs={8}>
                          <Box
                            sx={{
                              background: 'linear-gradient(135deg, #10b981 0%, #047857 100%)',
                              borderRadius: 2,
                              p: 2,
                              height: 120,
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              opacity: isAnimating ? 0.5 : 1,
                              transition: 'all 0.5s ease 0.1s'
                            }}
                          >
                            <Stack direction="row" spacing={1} alignItems="center">
                              <DragIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
                              <Typography sx={{ color: 'white', fontWeight: 600, fontSize: '0.85rem' }}>
                                Haber Listesi
                              </Typography>
                            </Stack>
                            <Typography sx={{ color: 'white', fontSize: '0.75rem' }}>
                              8 x 4
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={4}>
                          <Box
                            sx={{
                              background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)',
                              borderRadius: 2,
                              p: 2,
                              height: 120,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              opacity: isAnimating ? 0.5 : 1,
                              transition: 'all 0.5s ease 0.2s'
                            }}
                          >
                            <DragIcon sx={{ color: 'white', fontSize: '1.2rem', mb: 1 }} />
                            <Typography sx={{ color: 'white', fontWeight: 600, fontSize: '0.75rem', textAlign: 'center' }}>
                              Finans
                            </Typography>
                            <Typography sx={{ color: 'white', fontSize: '0.7rem' }}>
                              4 x 4
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Widget 4 - Footer */}
                      <Box
                        sx={{
                          background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
                          borderRadius: 2,
                          p: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          opacity: isAnimating ? 0.5 : 1,
                          transition: 'all 0.5s ease 0.3s'
                        }}
                      >
                        <Stack direction="row" spacing={1} alignItems="center">
                          <DragIcon sx={{ color: 'white', fontSize: '1.2rem' }} />
                          <Typography sx={{ color: 'white', fontWeight: 600, fontSize: '0.85rem' }}>
                            Kategori Widget
                          </Typography>
                        </Stack>
                        <Typography sx={{ color: 'white', fontSize: '0.75rem' }}>
                          12 x 3
                        </Typography>
                      </Box>
                    </Stack>

                    {/* Drag Indicator */}
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 20,
                        right: 20,
                        background: 'rgba(255, 107, 53, 0.9)',
                        color: 'white',
                        px: 2,
                        py: 1,
                        borderRadius: 2,
                        fontSize: '0.75rem',
                        fontWeight: 700,
                        animation: 'pulse 2s ease-in-out infinite'
                      }}
                    >
                      <DragIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
                      Görerek Tasarla
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>

        {/* Dalga Geçişi */}
        <Box
          sx={{
            position: 'absolute',
            bottom: '-130px',
            left: 0,
            width: '100%',
            overflow: 'hidden',
            lineHeight: 0
          }}
        >
          <svg
            viewBox="0 0 1440 400"
            preserveAspectRatio="none"
            style={{ width: '100%', height: '250px', display: 'block' }}
          >
            <path
              d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,181.3C960,192,1056,192,1152,176C1248,160,1344,128,1392,112L1440,96L1440,400L0,400Z"
              fill="#f8f9fa"
            />
          </svg>
        </Box>
      </Box>


      {/* Tasarımcı Özellikleri */}
      <Box
        sx={{
          background: 'white',
          py: { xs: 8, md: 12 }
        }}
      >
        <Container maxWidth="xl">
          <Grid container spacing={6} alignItems="center">
            {/* Sol - Özellikler */}
            <Grid item xs={12} md={6}>
              <Typography
                variant="overline"
                sx={{
                  color: '#ff6b35',
                  fontSize: '0.9rem',
                  fontWeight: 700,
                  letterSpacing: '0.1em'
                }}
              >
                TASARIMCI ÖZELLİKLERİ
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2.5rem', md: '3rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 3,
                  mt: 2
                }}
              >
                Güçlü ve{' '}
                <span style={{ color: '#ff6b35' }}>Kullanıcı Dostu</span>
              </Typography>

              <Typography
                sx={{
                  color: '#6c757d',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 5
                }}
              >
                Profesyonel web tasarımcıları tarafından geliştirilen, 
                ancak herkesin kolayca kullanabileceği güçlü araçlar.
              </Typography>

              {/* Feature List - 2 Column */}
              <Grid container spacing={3}>
                {designerFeatures.map((feature, index) => (
                  <Grid item xs={12} sm={6} key={index}>
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{
                        p: 2.5,
                        borderRadius: 3,
                        border: '2px solid #f1f3f5',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                          borderColor: feature.color,
                          background: `${feature.color}05`,
                          transform: 'translateY(-4px)',
                          boxShadow: `0 8px 24px ${feature.color}20`,
                          '& .feature-icon': {
                            background: feature.color,
                            color: 'white',
                            transform: 'rotate(10deg)'
                          }
                        }
                      }}
                    >
                      <Box
                        className="feature-icon"
                        sx={{
                          width: 50,
                          height: 50,
                          borderRadius: 2,
                          background: `${feature.color}15`,
                          color: feature.color,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          fontSize: '1.5rem',
                          flexShrink: 0,
                          transition: 'all 0.3s ease'
                        }}
                      >
                        {feature.icon}
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: '#1a1a2e',
                            fontSize: '0.95rem',
                            mb: 0.5
                          }}
                        >
                          {feature.title}
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: '0.8rem',
                            color: '#6c757d',
                            lineHeight: 1.4
                          }}
                        >
                          {feature.description}
                        </Typography>
                        <Chip
                          label={feature.stat}
                          size="small"
                          sx={{
                            mt: 1,
                            background: `${feature.color}15`,
                            color: feature.color,
                            fontWeight: 700,
                            fontSize: '0.7rem',
                            height: 22
                          }}
                        />
                      </Box>
                    </Stack>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            {/* Sağ - Görsel Demo */}
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
                  border: '8px solid #f1f3f5'
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1551650975-87deedd944c3?w=700&h=500&fit=crop"
                  alt="Designer Interface"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />

                {/* Feature Badges Overlay */}
                <Box
                  sx={{
                    position: 'absolute',
                    top: 20,
                    left: 20,
                    right: 20,
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: 1.5
                  }}
                >
                  {[
                    { icon: <DragIcon />, label: 'Drag & Drop', color: '#3b82f6' },
                    { icon: <GridIcon />, label: '12 Grid', color: '#10b981' },
                    { icon: <PreviewIcon />, label: 'Live Preview', color: '#f59e0b' }
                  ].map((badge, idx) => (
                    <Chip
                      key={idx}
                      icon={badge.icon}
                      label={badge.label}
                      sx={{
                        background: 'rgba(255,255,255,0.95)',
                        backdropFilter: 'blur(10px)',
                        color: badge.color,
                        fontWeight: 600,
                        fontSize: '0.8rem',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                        '& .MuiChip-icon': {
                          color: badge.color
                        }
                      }}
                    />
                  ))}
                </Box>

                {/* Bottom Info */}
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 20,
                    left: 20,
                    right: 20,
                    background: 'rgba(255,255,255,0.95)',
                    backdropFilter: 'blur(10px)',
                    borderRadius: 3,
                    p: 2.5,
                    boxShadow: '0 8px 24px rgba(0,0,0,0.15)'
                  }}
                >
                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '0.95rem' }}>
                        Anasayfa Tasarımı
                      </Typography>
                      <Typography sx={{ fontSize: '0.8rem', color: '#6c757d' }}>
                        Son güncelleme: 2 dakika önce
                      </Typography>
                    </Box>
                    <Stack direction="row" spacing={1}>
                      <IconButton
                        size="small"
                        sx={{
                          background: '#f1f3f5',
                          '&:hover': { background: '#e9ecef' }
                        }}
                      >
                        <SaveIcon sx={{ fontSize: '1.2rem', color: '#10b981' }} />
                      </IconButton>
                      <IconButton
                        size="small"
                        sx={{
                          background: '#f1f3f5',
                          '&:hover': { background: '#e9ecef' }
                        }}
                      >
                        <PreviewIcon sx={{ fontSize: '1.2rem', color: '#3b82f6' }} />
                      </IconButton>
                    </Stack>
                  </Stack>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Süreç Bölümü */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Dekoratif Grid */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)',
            backgroundSize: '50px 50px',
            opacity: 0.5
          }}
        />

        <Container maxWidth="xl" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#ff6b35',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              NASIL ÇALIŞIR?
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 2,
                mt: 2
              }}
            >
              4 Adımda Sayfa Tasarlayın
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: 'rgba(255,255,255,0.7)',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Basit ve hızlı tasarım süreci ile dakikalar içinde profesyonel sayfalar
            </Typography>
          </Box>

          {/* Timeline Style Steps */}
          <Box sx={{ position: 'relative', maxWidth: 1000, mx: 'auto' }}>
            {/* Connecting Line */}
            <Box
              sx={{
                position: 'absolute',
                top: 60,
                left: { xs: 30, md: 60 },
                right: { xs: 30, md: 60 },
                height: 4,
                background: 'linear-gradient(90deg, #3b82f6, #10b981, #f59e0b, #8b5cf6)',
                borderRadius: 2,
                display: { xs: 'none', md: 'block' }
              }}
            />

            <Grid container spacing={4}>
              {steps.map((step, index) => (
                <Grid item xs={12} sm={6} md={3} key={index}>
                  <Box
                    sx={{
                      textAlign: 'center',
                      position: 'relative'
                    }}
                  >
                    {/* Step Circle */}
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'inline-block',
                        mb: 3
                      }}
                    >
                      {/* Outer Ring */}
                      <Box
                        sx={{
                          width: 120,
                          height: 120,
                          borderRadius: '50%',
                          border: `4px solid ${step.color}30`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          background: `${step.color}10`,
                          position: 'relative',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            transform: 'scale(1.1)',
                            borderColor: step.color,
                            '& .step-icon': {
                              transform: 'scale(1.2) rotate(10deg)'
                            }
                          }
                        }}
                      >
                        {/* Inner Circle */}
                        <Box
                          className="step-icon"
                          sx={{
                            width: 90,
                            height: 90,
                            borderRadius: '50%',
                            background: step.color,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: 'white',
                            fontSize: '2.5rem',
                            boxShadow: `0 8px 24px ${step.color}60`,
                            transition: 'all 0.3s ease'
                          }}
                        >
                          {step.icon}
                        </Box>

                        {/* Number Badge */}
                        <Box
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            width: 40,
                            height: 40,
                            borderRadius: '50%',
                            background: 'white',
                            border: `3px solid ${step.color}`,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 800,
                            fontSize: '1.1rem',
                            color: step.color,
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
                          }}
                        >
                          {step.number}
                        </Box>
                      </Box>
                    </Box>

                    {/* Content */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: 'white',
                        mb: 1.5
                      }}
                    >
                      {step.title}
                    </Typography>

                    <Typography
                      sx={{
                        color: 'rgba(255,255,255,0.7)',
                        fontSize: '0.95rem',
                        lineHeight: 1.6,
                        px: 2
                      }}
                    >
                      {step.description}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
        </Container>
      </Box>

      {/* Video Demo Section */}
      {/* <Box
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
          py: { xs: 8, md: 12 }
        }}
      >
        <Container maxWidth="lg">
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography
                variant="overline"
                sx={{
                  color: '#ff6b35',
                  fontSize: '0.9rem',
                  fontWeight: 700,
                  letterSpacing: '0.1em'
                }}
              >
                CANLI DEMO
              </Typography>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '2.5rem', md: '3rem' },
                  fontWeight: 800,
                  color: '#1a1a2e',
                  mb: 3,
                  mt: 2
                }}
              >
                Tasarımcıyı{' '}
                <span style={{ color: '#ff6b35' }}>Canlı İzleyin</span>
              </Typography>

              <Typography
                sx={{
                  color: '#6c757d',
                  fontSize: '1.05rem',
                  lineHeight: 1.8,
                  mb: 4
                }}
              >
                2 dakikalık videomuzda sayfa tasarımcısının tüm özelliklerini 
                ve kullanım kolaylığını görün.
              </Typography>

              {/* Video Stats 
              <Stack spacing={3} mb={4}>
                {[
                  { icon: <TouchIcon />, label: 'Sürükle-Bırak', value: 'Kolay' },
                  { icon: <SpeedIcon />, label: 'Hızlı Tasarım', value: '5 Dakika' },
                  { icon: <CodeIcon />, label: 'Kod Bilgisi', value: 'Gerektirmez' }
                ].map((item, idx) => (
                  <Stack key={idx} direction="row" spacing={2} alignItems="center">
                    <Box
                      sx={{
                        width: 50,
                        height: 50,
                        borderRadius: 2,
                        background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem'
                      }}
                    >
                      {item.icon}
                    </Box>
                    <Box>
                      <Typography sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: '0.95rem' }}>
                        {item.label}
                      </Typography>
                      <Typography sx={{ color: '#ff6b35', fontWeight: 700, fontSize: '1.1rem' }}>
                        {item.value}
                      </Typography>
                    </Box>
                  </Stack>
                ))}
              </Stack>

              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                  color: 'white',
                  px: 5,
                  py: 2,
                  fontSize: '1.1rem',
                  fontWeight: 600,
                  borderRadius: '50px',
                  textTransform: 'none',
                  boxShadow: '0 8px 32px rgba(255, 107, 53, 0.4)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #f7931e 0%, #ff6b35 100%)',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px rgba(255, 107, 53, 0.5)'
                  }
                }}
              >
                Hemen Deneyin
              </Button>
            </Grid>

            <Grid item xs={12} md={6}>
              {/* Video Player Mockup 
              <Box
                sx={{
                  position: 'relative',
                  borderRadius: 4,
                  overflow: 'hidden',
                  boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
                  cursor: 'pointer',
                  '&:hover': {
                    '& .play-button': {
                      transform: 'scale(1.2)',
                      background: 'linear-gradient(135deg, #f7931e 0%, #ff6b35 100%)'
                    }
                  }
                }}
              >
                <img
                  src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=700&h=450&fit=crop"
                  alt="Video Demo"
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block'
                  }}
                />
                {/* Play Button 
                <Box
                  sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                  }}
                >
                  <Box
                    className="play-button"
                    sx={{
                      width: 100,
                      height: 100,
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontSize: '3rem',
                      boxShadow: '0 12px 40px rgba(255, 107, 53, 0.6)',
                      transition: 'all 0.3s ease',
                      border: '4px solid white'
                    }}
                  >
                    <PlayIcon sx={{ fontSize: '3rem', ml: 0.5 }} />
                  </Box>
                </Box>

                {/* Video Info 
                <Box
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.8) 100%)',
                    p: 3
                  }}
                >
                  <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '1.1rem' }}>
                    Sayfa Tasarımcısı Tanıtımı
                  </Typography>
                  <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: '0.9rem' }}>
                    2:30 dakika • 12K görüntülenme
                  </Typography>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box> */}


      {/* Widget Kategorileri */}
      <Box
        sx={{
          background: 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
          py: { xs: 8, md: 12 },
          position: 'relative'
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ textAlign: 'center', mb: 8 }}>
            <Typography
              variant="overline"
              sx={{
                color: '#ff6b35',
                fontSize: '0.9rem',
                fontWeight: 700,
                letterSpacing: '0.1em'
              }}
            >
              WİDGET KÜTÜPHANESİ
            </Typography>
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: '#1a1a2e',
                mb: 2,
                mt: 2
              }}
            >
              70+ Hazır Widget
            </Typography>
            <Typography
              variant="h6"
              sx={{
                color: '#6c757d',
                maxWidth: 700,
                mx: 'auto'
              }}
            >
              Her ihtiyaca uygun, özelleştirilebilir widget koleksiyonu
            </Typography>
          </Box>

          <Grid container spacing={3}>
            {widgetCategories.map((category, index) => (
              <Grid item xs={6} sm={4} md={3} key={index}>
                <Card
                  onMouseEnter={() => setHoveredWidget(index)}
                  onMouseLeave={() => setHoveredWidget(null)}
                  sx={{
                    height: '100%',
                    borderRadius: 4,
                    border: '2px solid #e2e8f0',
                    background: 'white',
                    transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                    cursor: 'pointer',
                    position: 'relative',
                    overflow: 'hidden',
                    transform: hoveredWidget === index ? 'translateY(-12px) scale(1.02)' : 'none',
                    boxShadow: hoveredWidget === index 
                      ? `0 20px 40px ${category.color}30`
                      : '0 2px 8px rgba(0,0,0,0.08)',
                    '&:hover': {
                      borderColor: category.color,
                      '& .widget-icon': {
                        transform: 'scale(1.2) rotate(10deg)',
                        filter: 'none'
                      },
                      '& .widget-count': {
                        background: category.color,
                        color: 'white',
                        transform: 'scale(1.1)'
                      }
                    },
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      height: 4,
                      background: category.color,
                      transform: hoveredWidget === index ? 'scaleX(1)' : 'scaleX(0)',
                      transformOrigin: 'left',
                      transition: 'transform 0.3s ease'
                    }
                  }}
                >
                  <CardContent sx={{ p: 3, textAlign: 'center' }}>
                    {/* Icon Emoji */}
                    <Box
                      className="widget-icon"
                      sx={{
                        fontSize: '3.5rem',
                        mb: 2,
                        display: 'inline-block',
                        transition: 'all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
                        filter: 'grayscale(0.3)'
                      }}
                    >
                      {category.icon}
                    </Box>

                    {/* Title */}
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: '#1a1a2e',
                        mb: 1,
                        fontSize: '1.1rem'
                      }}
                    >
                      {category.name}
                    </Typography>

                    {/* Description */}
                    <Typography
                      sx={{
                        color: '#6c757d',
                        fontSize: '0.85rem',
                        mb: 2,
                        lineHeight: 1.5
                      }}
                    >
                      {category.description}
                    </Typography>

                    {/* Count Badge */}
                    <Chip
                      className="widget-count"
                      label={category.count}
                      sx={{
                        background: `${category.color}15`,
                        color: category.color,
                        fontWeight: 800,
                        fontSize: '0.85rem',
                        height: 32,
                        transition: 'all 0.3s ease'
                      }}
                    />
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Toplam Widget Sayısı */}
          <Box
            sx={{
              textAlign: 'center',
              mt: 6,
              p: 4,
              background: 'linear-gradient(135deg, rgba(255, 107, 53, 0.05), rgba(247, 147, 30, 0.05))',
              borderRadius: 4,
              border: '2px dashed #ff6b35'
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: '2rem', md: '3rem' },
                fontWeight: 800,
                color: '#ff6b35',
                mb: 1
              }}
            >
              70+ Widget
            </Typography>
            <Typography
              sx={{
                color: '#6c757d',
                fontSize: '1.1rem'
              }}
            >
              Sürekli güncellenen ve genişleyen widget kütüphanesi
            </Typography>
          </Box>
        </Container>
      </Box>

      {/* CTA Section */}
    <Container maxWidth="md">
    <Box
        sx={{
          my: 10,
          background: 'linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)',
          py: { xs: 2, md: 3 },
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Pattern */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundImage: 'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
            backgroundSize: '30px 30px',
            opacity: 0.5
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 2 }}>
          <Box sx={{ textAlign: 'center' }}>
            <Box
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 80,
                height: 80,
                borderRadius: '50%',
                background: 'white',
                color: '#ff6b35',
                fontSize: '2.5rem',
                mb: 3,
                boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
              }}
            >
              <DesignIcon fontSize="large" />
            </Box>

            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                fontWeight: 800,
                color: 'white',
                mb: 3
              }}
            >
              Tasarlamaya Başlayın
            </Typography>
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              spacing={3}
              sx={{ justifyContent: 'center', mb: 5 }}
            >
              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowIcon />}
                sx={{
                  background: 'white',
                  color: '#ff6b35',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                  '&:hover': {
                    background: '#f8f9fa',
                    transform: 'translateY(-2px)',
                    boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
                  }
                }}
              >
                İletişime Geç
              </Button>

              <Button
                variant="outlined"
                size="large"
                startIcon={<PlayIcon />}
                sx={{
                  borderColor: 'white',
                  color: 'white',
                  px: 6,
                  py: 2.5,
                  fontSize: '1.2rem',
                  fontWeight: 700,
                  borderRadius: '50px',
                  textTransform: 'none',
                  borderWidth: 2,
                  '&:hover': {
                    background: 'rgba(255,255,255,0.1)',
                    borderColor: 'white',
                    borderWidth: 2
                  }
                }}
              >
                Demo İzle
              </Button>
            </Stack>
          </Box>
        </Container>
      </Box>
    </Container>

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes morph {
          0%, 100% {
            border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
          }
          25% {
            border-radius: 60% 40% 50% 50% / 30% 60% 40% 60%;
          }
          50% {
            border-radius: 50% 50% 30% 70% / 50% 30% 70% 40%;
          }
          75% {
            border-radius: 30% 70% 60% 40% / 60% 40% 50% 50%;
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }
      `}</style>
    </Box>
  );
};

export default PageDesignerPage;